module.exports = __webpack_public_path__ + "static/media/subpageHeader.fecbce15.png";